export const zh_CHT = {
    static: {
        taskActions: {
            pass: '通過',
            back: '駁回',
            refuse: '否決',
            more: '更多',
            viewLog: '審批日誌',
            viewFlowChart: '查看流程',
            viewBizlog: '審批日誌'
        },
        assignee: {
            title: '請選擇用戶',
            cancelAssign: '已取消操作。',
            noAssignee: '請至少選擇一個審批人。',
            successAssign: '操作成功。',
            errorAssign: '操作失敗，請聯系管理員查看原因！'
        },
        addsign: {
            title: '請選擇用戶',
            selectConsultant: '請選擇用戶。',
            successConsult: '征詢成功。',
            cancelSignUp: '已取消。'
        },
        transfer: {
            title: '請選擇用戶',
            selectHandover: '請選擇用戶。',
            successTransfer: '任務移交成功。'
        },
        columnName: {
            name: '名稱',
            code: '編號',
            department: '組織信息',
            organization: '組織',
            prcessName: '流程名稱',
            version: '版本'
        },
        common: {
            placeHolder: '請輸入'
        },
        submit: {
            selectProcess: '選擇流程',
            noProcess: '請選擇流程'
        },
        title: '審批確認',
        inputLabel: '審批意見',
        inputHolder: '請輸入審批意見',
        selectActivity: '目標節點',
        addSignee: '加簽人員',
        footOk: '確定',
        footCancel: '取消',
    },
    cueWords: {
        successClaim: '領用成功。',
        successUnClaim: '取消領用成功。',
        successRetrieve: '任務取回成功。',
        successPass: '審批通過。',
        successBack: '駁回成功。',
        successRefuse: '否決成功。',
        success: '操作成功'
    }
};
